module.exports = __webpack_public_path__ + "img/window-1.f6563e73.jpg";